import script from "./ShipmentTracking.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipmentTracking.vue?vue&type=script&setup=true&lang=js"

import "./ShipmentTracking.vue?vue&type=style&index=0&id=15a6fbad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a6fbad"]])

export default __exports__